var map = {
	"./ccavenue-live.png": 1403,
	"./ccavenue-sandbox.png": 1792,
	"./cod-live.png": 9468,
	"./cod-sandbox.png": 7363,
	"./paypal-live.png": 682,
	"./paypal-sandbox.png": 4085,
	"./paytm-live.png": 9669,
	"./paytm-sandbox.png": 7968,
	"./razorpay-live.png": 7669,
	"./razorpay-sandbox.png": 5743
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7379;